import { cx } from '@linaria/atomic';
import { TextProps } from '../../text';
import { getBaseBoolLayoutClassName } from './base-bool-layout.styles';
import { InlineLabel } from './inline-label.component';
import type { InlineLabelPlacement } from './types';

type Props = {
  children: React.ReactNode;
  className?: string;
  id: string;
  labelPlacement?: InlineLabelPlacement;
  label: React.ReactNode;
  labelDisabled?: boolean;
  disabled?: boolean;
  labelColor?: TextProps['color'];
};

export const BaseBoolLayout = ({
  children,
  className,
  id,
  labelPlacement = 'right',
  label,
  labelDisabled,
  disabled = false,
  labelColor = 'default',
}: Props) => (
  <div className={cx(getBaseBoolLayoutClassName(labelPlacement), className)}>
    {children}
    {!!label && (
      <InlineLabel id={id} disabled={labelDisabled ?? disabled} placement={labelPlacement} color={labelColor}>
        {label}
      </InlineLabel>
    )}
  </div>
);
